export const FIND_ASSIGNABLE_PRODUCT_FILES = `
  query FindAssignableFilesForProduct($filter: FindAssignableProductFilesFilter!, $page: PageRequest, $orderBy: OrderByInput) {
    product {
      findAssignableFilesForProduct(filter: $filter, page: $page, orderBy: $orderBy) {
        count
        limit
        offset
        items { id name inAssignments }
      }
    }
  }
`;
